import React, {Component} from 'react';
import download from 'downloadjs';
import axios from 'axios';
import FileDrop from '@zipwhip/zipkit/dist/components/inputs/file-drop';
import InputLabel from '@zipwhip/zipkit/dist/components/inputs/input-label';
import TextInput from '@zipwhip/zipkit/dist/components/inputs/text-input';
import AlertBanner from '@zipwhip/zipkit/dist/components/alert-banner';
import {OK, ERROR} from '@zipwhip/zipkit/dist/components/alert-banner/constants';
import { CsvIcon } from '@zipwhip/zipkit/dist/icons/CsvIcon';
import { LogoDark } from '@zipwhip/zipkit/dist/icons/LogoDark';
import { iconColor } from '@zipwhip/zipkit/dist/palette';
import StyledText from '@zipwhip/zipkit/dist/components/styled-text';
import HoverLink from '@zipwhip/zipkit/dist/components/hover-link';
import Button from '@zipwhip/zipkit/dist/components/button';
import CONFIG from './config.json';

const STYLE_BASE = 'csv-input-component_'

const MB_IN_BYTES = 1000000;

const ERROR_MAPPING = {
  notCsv: 'File type not supported. Please re-upload the file in CSV format.',
  upload: 'Could not upload the file. Please try again.',
  badToken: 'The token supplied is not valid.',
  noPhoneNumberfield: 'The CSV file uploaded was rejected. Please make sure it is in the correct format.',
  badCSV: 'The CSV file uploaded was rejected. Please make sure it is in the correct format.',
};

const csvTemplate = `phone_number,vendor_customer_id,use_case,display_name,legal_business_name,tax_identifier,business_type,business_vertical,stock_exchange,stock_symbol,street,city,state,zip,country,website,contact_name,contact_phone,contact_email,message_sample1,message_sample2,message_sample3,message_sample4,message_sample5,optin_message,message_flow,campaign_description,content_has_lending,content_has_embed_link,content_has_embed_phone,content_has_affiliate_marketing,content_has_age_gate`;

export default class CsvFileDrop extends Component {
  constructor(props) {
      super(props);
      this.fileDropRef = React.createRef();
    }

    state = {
      acceptedFile: null,
      error: null,
      extension: '',
      route: '',
      token: '',
      tokenInputValue: '',
      success: null,
    };
    checkFile(file, ext) {
      const reader = new FileReader();
      reader.onload = () => {

        const fileAsText = reader.result;
        if (fileAsText) {
          const rows = fileAsText.split('\n');
          if (rows && rows.length >= 1) {
            const cols = rows[0];
            if (cols.toLowerCase().indexOf('phone_number') !== -1) {
              this.setState({
                error: null,
                acceptedFile: file,
                extension: ext
              });
              return true;
            }
          }
        }
        this.setState({
          error: ERROR_MAPPING.noPhoneNumberfield,
        });
      };
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');

      reader.readAsText(file);
    }

    onDrop(acceptedFiles, rejectedFiles) {
      if (acceptedFiles.length) {
        const file = acceptedFiles[0];

        if (file.name && file.name.toLowerCase().indexOf('.csv') !== -1) {
          // if (FileReader) {
          //   this.checkFile(file, 'csv');
          // } else {
            this.setState({
              error: null,
              acceptedFile: file,
              extension: 'csv'
            });
          // }
        }
        // else if(ext && ext.indexOf('xlsx') !== -1){
        //   this.setState({
        //     error: null,
        //     acceptedFile: file,
        //     extension: ext
        //   });
        // }
        else {
          this.setState({
            ...this.state,
            error: ERROR_MAPPING.notCsv,
          });
        }
      } else if (rejectedFiles && rejectedFiles.length) {
        const reject = rejectedFiles[0];
        if (reject.name && reject.name.toLowerCase().indexOf('.csv') === -1) {
          this.setState({
            ...this.state,
            error: ERROR_MAPPING.notCsv,
          });
        }
      }
    }
    removeAcceptedFile() {
      this.setState({
        ...this.state,
        acceptedFile: null,
      });
    }

  renderFileDropChildren() {
    const { acceptedFile } = this.state;
    if (acceptedFile) {
      const { size = 0, name = '' } = acceptedFile;
      return (
        <div className={`zw-default-div-style ${STYLE_BASE}droppedFileContainer`}>
          <div className={`zw-default-div-style ${STYLE_BASE}fileRow`} data-testid="CSV_FILE_ROW">
            <CsvIcon height={24} width={24} color={iconColor} />
            <StyledText className={`${STYLE_BASE}fileName`} numberOfLines={1}>
              {name || 'no-name.csv'}
            </StyledText>
            <StyledText type="small" className={`${STYLE_BASE}byteSize`}>
              {size}
            </StyledText>
            <HoverLink
              className={`${STYLE_BASE}removeLink`}
              testid="REMOVE_CSV"
              onPress={() => {
                this.removeAcceptedFile();
              }}
            >
              Remove
            </HoverLink>
          </div>
        </div>
      );
    }
    return (
      <div className={`zw-default-div-style ${STYLE_BASE}fileDropChildContainer`}>
        <StyledText className={`${STYLE_BASE}childText`}>
          Drop .csv file here to upload or click to
          <HoverLink
            onClick={e => {
              e.stopPropagation();
              this.fileDropRef && this.fileDropRef.current.open();
            }}
            className={`${STYLE_BASE}childLink`}
          >
            Browse.
          </HoverLink>
        </StyledText>
      </div>
    );
  }

  onTokenChange  = (e)=>{
    if (e && e.target && e.target.value){
      const routeAndToken = e.target.value.split('-');

      this.setState({
        tokenInputValue:  e.target.value,
        route: routeAndToken[0],
        token: routeAndToken.length === 2 ? routeAndToken[1] : ''
      })
    }
  }

  importBSI = () => {
    const { acceptedFile, token, route, extension} = this.state;

    if(acceptedFile && token && route && extension){
      this.setState({
        pending: true,
      },async ()=>{
        const res = await axios.post(
          `${CONFIG.UPLOAD_URL}/upload/${route}/${extension}`,
          acceptedFile,
          {
            headers:{
              'Content-Type': 'text/csv',
              'Access-Control-Allow-Origin': '*',
              'Authorization': token
            }
        }).catch(()=>{
          console.log('CORS ERROR');
        });
        if(res && res.status === 200){
          this.setState({
            acceptedFile: null,
            error: null,
            extension: '',
            route: '',
            token: '',
            tokenInputValue: '',
            pending: false,
            success: true
          })
        }
        else if(!res){
          this.setState({
            error: ERROR_MAPPING.badToken,
            route: '',
            token: '',
            tokenInputValue: '',
            pending: false,
            success: false
          });
        }
        else if (res.status === 400){
          this.setState({
            error: ERROR_MAPPING.badCSV,
            acceptedFile: null,
            pending: false,
            success: false
          });
        } else if(res.status === 404){
          this.setState({
            error: ERROR_MAPPING.badToken,
            route: '',
            token: '',
            tokenInputValue: '',
            pending: false,
            success: false
          });
        } else {
          this.setState({
            error: ERROR_MAPPING.upload,
            pending: false,
            success: false
          })
        }
      })
    }
  }

  renderSuccessBanner = () =>{
    return(
      <AlertBanner
        onClose={()=>{this.setState({success:null})}}
        type={OK}
      >CSV was successfully uploaded</AlertBanner>
    );
  }

  render(){
    const { acceptedFile,error, success, token, route, pending } = this.state;
    return (
      <div
        className={`zw-default-div-style ${STYLE_BASE}fileDropContainer`}
        data-testid="DROPZONE_CONTAINER"
      >
        <div className='csv-input-component_logo'><LogoDark/></div>
        <StyledText type="h2"> Upload CSV File</StyledText>
        <StyledText className={`${STYLE_BASE}subText`}>
          To successfully import CSV please use our
          <HoverLink
            className={`${STYLE_BASE}templateLink`}
            testid="TEMPLATE_LINK"
            accessibilityRole="link"
            onPress={() => {
              download(csvTemplate, 'CSV Import Template.csv', 'text/csv');
            }}
          >
            CSV template.
          </HoverLink>
          Last Updated 2022-11-18.
        </StyledText>
        {success ? this.renderSuccessBanner() : null}
        { error ? <AlertBanner onClose={()=>{this.setState({error:null})}}type={ERROR}>{error}</AlertBanner> : null}
        <InputLabel>Token</InputLabel>
        <TextInput
          value={this.state.tokenInputValue}
          onChangeText={this.onTokenChange}
        />
        <InputLabel>CSV file to import</InputLabel>
        <FileDrop
          accept={null}
          acceptMsg={`Drop .csv file to attach.`}
          disableClick={!!acceptedFile}
          id="CSV_FILE_DROP"
          maxSize={2 * MB_IN_BYTES}
          multiple={false}
          ref={this.fileDropRef}
          onDrop={(acceptedFiles, rejectedFiles) => {
            console.log('hit here ')
            this.onDrop(acceptedFiles, rejectedFiles);
          }}
          rejectMsg={ERROR_MAPPING.rejectMsg}
          stickyChildren
        >
          {this.renderFileDropChildren()}
        </FileDrop>
        <Button
          className={`${STYLE_BASE}importButton`}
          disabled={!acceptedFile || !token || !route || pending}
          onClick={this.importBSI}
          primary
          large
          testid={
            acceptedFile ? 'CONTACT_IMPORT_BUTTON_ENABLED' : 'CONTACT_IMPORT_BUTTON_DISABLED'
          }
        >
          Import
        </Button>
      </div>
    );
  }
}
